import React from "react";
import { Box, Typography, Grid, Paper, Fade } from "@mui/material";
import { Send, Schedule, Message } from "@mui/icons-material";

function ProcessSteps() {
  const steps = [
    {
      icon: <Message sx={{ fontSize: 40, color: "#0066CC", mb: 2 }} />,
      title: "Quick Response",
      description: "I'll get back to you within 24 hours",
    },
    {
      icon: <Schedule sx={{ fontSize: 40, color: "#0066CC", mb: 2 }} />,
      title: "Consultation",
      description: "Free initial consultation to discuss your needs",
    },
    {
      icon: <Send sx={{ fontSize: 40, color: "#0066CC", mb: 2 }} />,
      title: "Project Planning",
      description: "Detailed proposal and timeline for your project",
    },
  ];

  return (
    <Box sx={{ mt: 8 }}>
      <Fade in timeout={1600}>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <Typography
            variant="h5"
            component="h3"
            gutterBottom
            sx={{ fontWeight: 600 }}
          >
            What Happens Next?
          </Typography>
          <Grid container spacing={3} sx={{ mt: 2 }}>
            {steps.map((step, index) => (
              <Grid item xs={12} sm={4} key={step.title}>
                <Box sx={{ p: 2 }}>
                  {step.icon}
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {step.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {step.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Fade>
    </Box>
  );
}

export default ProcessSteps;
